import { create } from 'zustand';

interface CodefState {
  token?: string;
  isLicensed?: boolean;
  isInitialized?: boolean;
}

interface CodefStore {
  codefState: CodefState;
  setCodefState: (codefState: CodefState) => void;
}

const initialState: Pick<CodefStore, 'codefState'> = {
  codefState: {
    token: undefined,
    isLicensed: false,
  },
};

const useCodefStore = create<CodefStore>((set, get) => ({
  ...initialState,
  setCodefState: (codefState) =>
    set(() => {
      return { codefState: { ...get().codefState, ...codefState } };
    }),
}));

export default useCodefStore;
